import { usePathname } from 'expo-router';
import Head from 'expo-router/head';

import { PostInfo } from './types';

import { resolveAssetUri } from '@/utils/resolveMetroAsset';
import { LD_REACTIIVE } from '@/data/structured';

export function BlogHead({
  info,
  basePath = 'articles',
}: {
  info: PostInfo;
  basePath?: string;
}) {
  const pathname = usePathname();
  const img =
    resolveAssetUri(info.featuredImage) ?? `/${basePath}/og-image/${info.slug}`;
  const imgUrl = `https://reactiive.io${img}`;
  const url = `https://reactiive.io${pathname}`;

  return (
    <Head>
      <title>{info.title}</title>
      <meta name="description" content={info.subtitle} />
      {/* TODO: Dynamic */}
      <meta name="keywords" content={info.tags.join(',')} />

      <meta property="og:image:secure_url" content={imgUrl} />
      <meta property="og:image" content={imgUrl} />
      <meta property="og:image:alt" content={info.subtitle} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={info.title} />
      <meta property="og:description" content={info.subtitle} />
      <meta property="og:url" content={url} />
      <meta property="og:published_time" content={info.date} />

      <meta property="twitter:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={info.title} />
      <meta name="twitter:description" content={info.subtitle} />
      <meta name="twitter:image" content={imgUrl} />

      <script id="ld+article" type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'NewsArticle',
          headline: info.title,
          preview: info.subtitle,
          slug: info.slug,
          url: url,
          status: 'Published',
          image: [imgUrl],
          datePublished: info.date,
          dateModified: info.date,
          author: [LD_REACTIIVE],
        })}
      </script>
    </Head>
  );
}
